// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"hv_a bfq_je","CommentListPlaceholder--Legacy":"hv_b bfq_qg bfq_vi"};